// @ts-nocheck
import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { RootState } from 'src/store/reducers';

import PageLayout from '@components/PageLayout';
import AddCreditCardForm from '@components/my-profile/payment-methods/AddCreditCardForm';
import PaymentMethodsList from '@components/my-profile/payment-methods/PaymentMethodsList';

import * as actions from '@redux-actions/';

import { getPaymentMethods } from '@services/myProfileServices';

import { getLabelFallback } from '@utils/utils';
import LoaderElement from '@loaders/LoaderElement';

const PaymentMethods = (): JSX.Element => {
    const myPaymentMethodsTitle = getLabelFallback('PAYMENT_METHODS_TITLE');
    const myPaymentMethodsBackLabel = getLabelFallback('PAYMENT_METHODS_BACK_CTA_LABEL');

    const [isAddFormVisible, setIsAddFormVisible] = useState<boolean>(false);

    const isMobile = useSelector((state: RootState) => state.common.isMobile);
    const config = useSelector((state: RootState) => state.common.config);
    const getPaymentMethodsListRequestStatus = useSelector(
        (state: RootState) => state.myProfile.getPaymentMethodsListRequestStatus
    );
    const paymentMethodsList = useSelector(
        (state: RootState) => state.myProfile.paymentMethodsList
    );

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getPaymentMethods(config.mockRequest, config.storeId));
        return () => {
            dispatch(actions.getPaymentMethodsPending());
        };
    }, []);

    const handleShowAddCcForm = (showForm: boolean) => {
        setIsAddFormVisible(showForm);
    };

    return (
        <PageLayout
            data_element_id="AccountSummary_Profile"
            hideMenu
            labelMenu={myPaymentMethodsTitle}
            backLabel={myPaymentMethodsBackLabel}
        >
            <div className="payment-methods">
                {!isMobile && (
                    <div
                        role="region"
                        aria-label="My payment methods page title"
                        className="primary-title mb-32"
                    >
                        {myPaymentMethodsTitle}
                    </div>
                )}

                {getPaymentMethodsListRequestStatus === 'LOADING' && (
                    <div className="payment-methods_list ">
                        <div className="container">
                            <LoaderElement height={240} />
                            <LoaderElement height={240} />
                            <LoaderElement height={240} />
                            <LoaderElement height={240} />
                        </div>
                    </div>
                )}

                {getPaymentMethodsListRequestStatus === 'SUCCESS' &&
                    paymentMethodsList?.payments.length > 0 && (
                        <PaymentMethodsList
                            paymentMethods={paymentMethodsList}
                            showAddCreditCardForm={handleShowAddCcForm}
                            hideButton={isAddFormVisible}
                        />
                    )}
                {((getPaymentMethodsListRequestStatus === 'SUCCESS' &&
                    !paymentMethodsList?.payments.length) ||
                    isAddFormVisible) && <AddCreditCardForm />}
            </div>
        </PageLayout>
    );
};

export default PaymentMethods;
